var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCitizenCardIssuedate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_43192",
    "data-name": "Group 43192",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_22329",
    "data-name": "Group 22329"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9880",
    "data-name": "Rectangle 9880",
    width: 16,
    height: 16,
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "calendar_4_",
    "data-name": "calendar (4)",
    transform: "translate(1 1.083)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23654",
    "data-name": "Path 23654",
    d: "M18.54,2.539h1.4v.932a.468.468,0,1,0,.932,0V.89a.468.468,0,1,0-.932,0V1.6h-1.4a.468.468,0,1,0,0,.932Z",
    transform: "translate(-10.14 -0.377)",
    fill: "#b2b9c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23655",
    "data-name": "Path 23655",
    d: "M11.186,2.656h1.4v.932a.468.468,0,0,0,.932,0V1.006a.468.468,0,0,0-.932,0v.713h-1.4a.468.468,0,0,0,0,.932Z",
    transform: "translate(-6.054 -0.493)",
    fill: "#b2b9c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23656",
    "data-name": "Path 23656",
    d: "M12.132,1.6h-.464a.468.468,0,1,0,0,.932h.468a.936.936,0,0,1,.932.932v1.4H.932v-1.4a.936.936,0,0,1,.936-.932h1.4v.932a.468.468,0,1,0,.932,0V.89a.468.468,0,1,0-.932,0V1.6h-1.4A1.868,1.868,0,0,0,0,3.471v8.868a1.868,1.868,0,0,0,1.868,1.872H12.132A1.868,1.868,0,0,0,14,12.339V3.471A1.868,1.868,0,0,0,12.132,1.6Zm0,11.668H1.868a.936.936,0,0,1-.932-.932V5.808H13.068v6.532A.936.936,0,0,1,12.132,13.271Z",
    transform: "translate(0 -0.377)",
    fill: "#b2b9c4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCitizenCardIssuedate);
export default __webpack_public_path__ + "static/media/citizen-card-issuedate.288d5da04d9dc3014bda5b2c9c53dd4a.svg";
export { ForwardRef as ReactComponent };